const menus = [
  {
    name: "",
    label: "Accueil",
  },
  {
    name: "company",
    label: "Necoh",
    items: [
      { name: "a-propos", label: "A propos de nous" },
      {
        name: "services",
        label: "Nos services",
        items: [
          { name: "services/comptabilite", label: "Comptabilité" },
          { name: "services/audit", label: "Audit" },
          { name: "services/social", label: "Paie & RH" },
          { name: "services/fiscalite", label: "Fiscalité des particuliers" },
          { name: "services/conseil", label: "Conseil" },
          { name: "services/juridique", label: "Juridique" },
        ],
      },
      { name: "emploi", label: "Nous rejoindre" },
      { name: "contact", label: "Nous contacter" },
      { name: "outils", label: "Liens et outils" },
    ],
  },
  {
    name: "ressources",
    label: "Actualités",
    items: [{ name: "articles", label: "Actualités règlementaires" }],
  },
]

function filterMenuItems(menus) {
  if (process.env.GATSBY_PUBLISH_MODE === "production") {
    const namesToFilter = ["clients"]

    return menus.filter(item => {
      if (item.items) {
        item.items = filterMenuItems(item.items, namesToFilter)
      }
      return !namesToFilter.includes(item.name)
    })
  } else return menus
}

export const menuItems = filterMenuItems(menus)
